// extracted by mini-css-extract-plugin
export var label = "_cd-1";
export var reminder = "_cd-0";